export * from "./ATypeAmenity";
